import { dbVersion } from '../models/Constants';
import { getDbName, getLastUiSyncTimestampStorageKey, getSyncTimestampStorageKey, } from '../utilities/DatabaseUtilities';
import { getEdgeworthDb } from './getEdgeworthDb';
var dbPromise;
var currentPuid;
var currentWorkload;
var allowDbAccess = true;
var dbVersionOffset = 1;
export function getCachedSyncTimestampStorageKey() {
    return getSyncTimestampStorageKey(currentWorkload, dbVersion + dbVersionOffset);
}
export function getCachedLastUiSyncTimestampStorageKey() {
    return getLastUiSyncTimestampStorageKey(currentWorkload);
}
export function setDbStates(dbStates) {
    var puid = dbStates.puid, workload = dbStates.workload, database = dbStates.database;
    currentWorkload = workload.toLowerCase();
    currentPuid = puid;
    dbPromise = database;
}
/**
 * Function that initializes IDB instance to be used later. Calling this function without passing puid starts early prefetch from IDB,
 * using puid that is cached in local storage from previous sessions. Any subsequent calls that passes puid will override the IDB instance.
 * @param puid PUID used to associate the corresponding IDB instance
 * @param onBlocking Called when there are newer tabs accessing a new IDB version (so current tab is on obsolete version)
 * @returns N/A
 */
export function initEdgeworthDb(puid, workload, databaseVersionOffset, onBlocking) {
    if (!workload || !puid) {
        throw new Error('workload/puid cannot be empty');
    }
    else if (!!dbPromise && puid === currentPuid) {
        // skip if db already initialized, and puid is same as cached puid
        return;
    }
    currentWorkload = workload.toLowerCase();
    currentPuid = puid;
    if (typeof databaseVersionOffset === 'number') {
        dbVersionOffset = databaseVersionOffset;
    }
    var dbName = getDbName(currentWorkload, currentPuid);
    dbPromise = getEdgeworthDb(dbName, dbVersion + dbVersionOffset, currentWorkload, currentPuid, onBlocking, function () {
        allowDbAccess = false;
    });
}
export function getCachedEdgeworthDb() {
    if (!allowDbAccess) {
        throw new Error('Database Access Not Allowed.');
    }
    else if (!dbPromise) {
        // db not yet initialized
        throw new Error('initEdgeworthDb needs to be called first');
    }
    return dbPromise;
}
//# sourceMappingURL=EdgeworthDb.js.map